import { useEffect } from 'react';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { t } from '../../../languages';
import { loadRanking } from '../../../modules/user';
import { formatMS2MMSS } from '../../../utils';
import TutorManager from '../../TutorManager';
import Points from '../Points';
import FullScreenButton from './FullScreenButton';
import './index.less';


const SectionHeader = ({ section, lang, user, theClass, today_time, loadRanking, ranking }) => {


  // console.log('SectionHeader user:', user, ranking);

  useEffect(() => {
    // loadRanking();

    return () => {
    }

  }, []);

  useEffect(() => {
    // loadRanking();
  }, [user.points]);
  
  const isProfile = section === 'profile';
  const profileStyle = section === 'profile' ? { marginRight: 0 } : null;
  const isTeach = section === 'teach';
  const isCompetitions = section === 'competitions';

  return (<>

    {!(isProfile || isTeach || isCompetitions) ? <TutorManager section={section} /> : null}

    <section className="levels-header-logo">
      <div className="inner-logo">
        <FullScreenButton />
        <img className='logo' src="./static/logo_mis.png" alt="" style={profileStyle} />
        {section !== 'profile' && section !== 'teach' ? <div className="levels-header-points-time">
          <span className='time'>{formatMS2MMSS(today_time)}</span>
          {section !== 'course' && section !== 'resources' ? <Points points={user.points} /> : null}
        </div> : null}
      </div>
    </section>
    <section className="levels-header-title">
      {user.joinedToClass && theClass && !isProfile ? <h4 className='class-name'>{t(lang, 'class')} {theClass.name}</h4> : null}
      <h1>{t(lang, section)}</h1>
    </section>
  </>
  );
};

const mapStateToProps = ({ user, aclass }) => ({
  user: user.user,
  lang: user.lang,
  ranking: user.ranking,
  today_time: user.today_time,
  theClass : aclass.current
});

const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      loadRanking
    },
    dispatch
  );

export default connect(mapStateToProps, mapDispatchToProps)(SectionHeader);
